module.exports = __webpack_public_path__ + "static/media/two-kids-stirring.41de7efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/two-kids-stirring.jpg
// module id = 817
// module chunks = 0